module.exports = __webpack_public_path__ + "media/src/images/example_voucher_card_fr-1eb2745c75c2e42c690c7812f3d8a18f.jpg";